var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import { AdvancedSelect, Decorator, Input } from '@myhealth-raccoon/components';
import { useController } from 'react-hook-form';
import padStart from 'lodash/padStart';
var months = [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
];
var plainRegex = /^\d{0,4}-\d{0,2}-\d{0,2}$/;
function yearToDateString(year, currentValue) {
    if (plainRegex.test(currentValue)) {
        return "".concat(year).concat(currentValue.substring(currentValue.indexOf('-')));
    }
    else {
        return "".concat(year, "--");
    }
}
function monthToDateString(month, currentValue) {
    if (plainRegex.test(currentValue)) {
        var indexOfDash = currentValue.indexOf('-');
        return "".concat(currentValue.substring(0, indexOfDash + 1)).concat(month).concat(currentValue.substring(currentValue.indexOf('-', indexOfDash + 1)));
    }
    else {
        return "-".concat(month, "-");
    }
}
function dayToDateString(day, currentValue) {
    day = padStart(day, 2, "0");
    if (plainRegex.test(currentValue)) {
        var indexOfDash = currentValue.lastIndexOf('-');
        return "".concat(currentValue.substring(0, indexOfDash + 1)).concat(day);
    }
    else {
        return "--".concat(day);
    }
}
export var DateInput = function (_a) {
    var control = _a.control, defaultValue = _a.defaultValue, name = _a.name, rules = _a.rules, shouldUnregister = _a.shouldUnregister, id = _a.id, decoratorProps = __rest(_a, ["control", "defaultValue", "name", "rules", "shouldUnregister", "id"]);
    var _b = useController({ control: control, name: name, rules: rules, defaultValue: defaultValue, shouldUnregister: shouldUnregister }), _c = _b.field, onChange = _c.onChange, value = _c.value, fieldName = _c.name, onBlur = _c.onBlur, ref = _c.ref, fieldState = _b.fieldState;
    // YYYY-MM-DD
    var day = (value === null || value === void 0 ? void 0 : value.split('-')[2]) || "";
    var month = (value === null || value === void 0 ? void 0 : value.split('-')[1]) || "";
    var year = (value === null || value === void 0 ? void 0 : value.split('-')[0]) || "";
    var onInputChange = useCallback(function (e) {
        var monthId = Number.parseInt(e);
        if (!isNaN(monthId) && monthId >= 1 && monthId <= 12) {
            onChange(monthToDateString(months[monthId - 1].value, value));
        }
    }, [onChange, value]);
    return React.createElement(Decorator, __assign({ fieldError: fieldState.error, fieldset: true, id: id }, decoratorProps),
        React.createElement("div", { className: 'grid grid-cols-4 gap-2 sm:gap-4' },
            React.createElement(Input, { error: !!fieldState.error, value: day.replace(/^0(\d)$/, "$1"), inputMode: 'numeric', label: 'Day', placeholder: 'DD', maxLength: 2, id: id && "".concat(id, "_day"), onChange: function (e) { return onChange(dayToDateString(e.target.value, value)); }, name: "".concat(fieldName, ".day") }),
            React.createElement(Decorator, { id: id && "".concat(id, "_month"), label: "Month", error: !!fieldState.error, className: 'col-span-2' },
                React.createElement(AdvancedSelect, { error: !!fieldState.error, className: 'col-span-2', value: months.find(function (m) { return m.value === month; }), options: months, id: id && "".concat(id, "_month"), onChange: function (month) { return onChange(monthToDateString(month.value, value)); }, placeholder: 'Select Month', name: "".concat(fieldName, ".month"), blurInputOnSelect: true, onInputChange: onInputChange })),
            React.createElement(Input, { label: "Year", placeholder: 'YYYY', id: id && "".concat(id, "_year"), error: !!fieldState.error, inputMode: 'numeric', maxLength: 4, onChange: function (e) { return onChange(yearToDateString(e.target.value, value)); }, value: year, name: "".concat(fieldName, ".year"), onBlur: onBlur }),
            React.createElement(Input, { type: 'hidden', className: 'invisible absolute', tabIndex: -1, name: name, id: id, ref: ref })));
};
